/* eslint-disable react/no-danger */
/* eslint-disable no-alert */
/* eslint-disable no-console */
import { trackSelectPromotionEvent } from "@DSG/Common/DSGTracking";
import parse from "html-react-parser";
import DSGProductCarouselProduct from "@DSG/Components/DSGProductCarouselProduct";
import colorPallete, {
    bodyFonts,
    buttonFonts,
    elevation,
    headlineFonts,
    themeFontWeights,
} from "@DSG/MobiusOverrides/styles/variables";
import Carousel, { CarouselSlide } from "@DSG/Overrides/Components/Carousel";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { extractStylesToArray, isSafe } from "@insite/client-framework/Common/Utilities/isSafeStyles";
import isTouchDevice from "@insite/client-framework/Common/Utilities/isTouchDevice";
import { CategoryContext } from "@insite/client-framework/Components/CategoryContext";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadCarouselProducts from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import {
    getErrorMessage,
    getProductsForProductInfoList,
} from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import sendImpressionTracking from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/SendImpressionTracking";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductCarouselProductStyles } from "@insite/content-library/Components/ProductCarouselProduct";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Tab, { TabPresentationProps } from "@insite/mobius/Tab";
import TabGroup, { TabGroupPresentationProps } from "@insite/mobius/TabGroup";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { injectCss } from "@insite/mobius/utilities";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as cssLinter from "css";
import { useEmblaCarousel } from "embla-carousel/react";
import React, { createRef, useCallback, useContext, useEffect, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css, ThemeProps, withTheme } from "styled-components";

const enum fields {
    title = "title",
    carouselType = "carouselType",
    displayProductsFrom = "displayProductsFrom",
    selectedCategoryIds = "selectedCategoryIds",
    relatedProductType = "relatedProductType",
    numberOfProductsToDisplay = "numberOfProductsToDisplay",
    seedWithManuallyAssigned = "seedWithManuallyAssigned",
    maxNumberOfColumns = "maxNumberOfColumns",
    widgetPosition = "widgetPosition",
    showImage = "showImage",
    showTitle = "showTitle",
    showBrandName = "showBrandName",
    showPartNumbers = "showPartNumbers",
    showPrice = "showPrice",
    showAddToCart = "showAddToCart",
    showAddToList = "showAddToList",
    showImageBadges = "showImageBadges",
    maximumNumberOfImageBadges = "maximumNumberOfImageBadges",
    showTextBadges = "showTextBadges",
    maximumNumberOfTextBadges = "maximumNumberOfTextBadges",
    visibleElementsTitle = "visibleElementsTitle",
    titleAlignment = "titleAlignment",
    customCSS = "customCSS",
    tab1Label = "tab1Label",
    tab1ProductNumbers = "tab1ProductNumbers",
    tab1Content = "tab1Content",
    tab2Label = "tab2Label",
    tab2ProductNumbers = "tab2ProductNumbers",
    tab2Content = "tab2Content",
    tab3Label = "tab3Label",
    tab3ProductNumbers = "tab3ProductNumbers",
    tab3Content = "tab3Content",
    tab4Label = "tab4Label",
    tab4ProductNumbers = "tab4ProductNumbers",
    tab4Content = "tab4Content",
    tab5Label = "tab5Label",
    tab5ProductNumbers = "tab5ProductNumbers",
    tab5Content = "tab5Content",
    showViewProduct = "showViewProduct",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.carouselType]: string;
        [fields.displayProductsFrom]: string;
        [fields.selectedCategoryIds]: string[];
        [fields.relatedProductType]: string;
        [fields.numberOfProductsToDisplay]: number;
        [fields.seedWithManuallyAssigned]: string;
        [fields.maxNumberOfColumns]: number;
        [fields.widgetPosition]: number;
        [fields.showImage]: boolean;
        [fields.showTitle]: boolean;
        [fields.showBrandName]: boolean;
        [fields.showPartNumbers]: boolean;
        [fields.showPrice]: boolean;
        [fields.showAddToCart]: boolean;
        [fields.showAddToList]: boolean;
        [fields.showImageBadges]: boolean;
        [fields.maximumNumberOfImageBadges]: number;
        [fields.showTextBadges]: boolean;
        [fields.maximumNumberOfTextBadges]: number;
        [fields.visibleElementsTitle]: string;
        [fields.titleAlignment]: string;
        [fields.customCSS]: string;
        [fields.tab1Label]: string;
        [fields.tab1Content]: string;
        [fields.tab1ProductNumbers]: string[];
        [fields.tab2Label]: string;
        [fields.tab2Content]: string;
        [fields.tab2ProductNumbers]: string[];
        [fields.tab3Label]: string;
        [fields.tab3Content]: string;
        [fields.tab3ProductNumbers]: string[];
        [fields.tab4Label]: string;
        [fields.tab4Content]: string;
        [fields.tab4ProductNumbers]: string[];
        [fields.tab5Label]: string;
        [fields.tab5Content]: string;
        [fields.tab5ProductNumbers]: string[];
        [fields.showViewProduct]: boolean;
    };
}

const PreArrow = styled.button`
    display: none;
    position: absolute;
    left: 8px;
    padding: 0;
    min-width: 40px;
    min-height: 40px;
    border-radius: 50%;
    border: 1px solid ${colorPallete.grey200};
    background: ${colorPallete.white};
    color: ${colorPallete.grey800};
    z-index: 401;
    box-shadow: ${elevation.dp04};
    cursor: pointer;

    [class*="ButtonIcon--"] {
        color: ${colorPallete.grey800};
    }

    &:not(:disabled):hover {
        background: ${colorPallete.white};
        color: ${colorPallete.black};
        border: 1px solid ${colorPallete.grey100};

        [class*="ButtonIcon--"] {
            color: ${colorPallete.black};
        }
    }

    @media only screen and (max-width: 768px) {
        padding: 0;
    }
`;

const NextArrow = styled.button`
    display: none;
    position: absolute;
    right: 8px;
    top: 0;
    padding: 0;
    min-width: 40px;
    min-height: 40px;
    border-radius: 50%;
    border: 1px solid ${colorPallete.grey200};
    background: ${colorPallete.white};
    color: ${colorPallete.grey800};
    z-index: 401;
    box-shadow: ${elevation.dp04};
    cursor: pointer;

    [class*="ButtonIcon--"] {
        color: ${colorPallete.grey800};
    }

    &:not(:disabled):hover {
        background: ${colorPallete.white};
        color: ${colorPallete.black};
        border: 1px solid ${colorPallete.grey100};

        [class*="ButtonIcon--"] {
            color: ${colorPallete.black};
        }
    }
    @media only screen and (max-width: 768px) {
        display: block;
        padding: 0;
    }
`;

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    products: getProductsForProductInfoList(state, ownProps.id),
    errorMessage: getErrorMessage(state, ownProps.id),
    pageType: getCurrentPage(state).type,
    productRecommendationWidgets: state.components.productRecommendations.widgets,
    session: state.context.session,
});

const mapDispatchToProps = {
    loadCarouselProducts,
    sendImpressionTracking,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme> &
    HasShellContext;

export interface DSGProductSpotlightCarouselStyles {
    errorMessageText?: TypographyPresentationProps;
    sectionContentWrapper: InjectableCss;
    contentWrapper: InjectableCss;
    titleText?: TypographyPresentationProps;
    skipCarouselButton?: SkipNavStyles;
    mainContainer?: GridContainerProps;
    prevArrowGridItem?: GridItemProps;
    prevArrowButton?: ButtonPresentationProps;
    nextArrowGridItem?: GridItemProps;
    nextArrowButton?: ButtonPresentationProps;
    carouselGridItem?: GridItemProps;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    carouselSlidesContainer?: InjectableCss;
    carouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    carouselProductStyles?: ProductCarouselProductStyles;
    productSpotlightTabGroup?: TabGroupPresentationProps;
    tabGroupWrapper: InjectableCss;
    tab1?: TabPresentationProps;
    tab2?: TabPresentationProps;
    tab3?: TabPresentationProps;
    tab4?: TabPresentationProps;
    tab5?: TabPresentationProps;
}

export const DSGProductSpotlightCarouselStyles: DSGProductSpotlightCarouselStyles = {
    errorMessageText: {
        color: "danger",
        css: css`
            margin-top: 20px;
        `,
    },
    titleText: {
        forwardAs: "div",
        css: css`
            text-align: center;
        `,
    },
    sectionContentWrapper: {
        css: css`
            justify-content: center;
            margin-bottom: 24px;
            [class*="TypographyStyle-"] {
                font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                font-weight: ${themeFontWeights.semiBold};
                color: ${colorPallete.black90};
                margin: 0;
            }

            @media only screen and (max-width: 768px) {
                margin-bottom: 22px;
                [class*="TypographyStyle-"] {
                    font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                    font-weight: ${headlineFonts.headline2SemiBoldLg.fontWeight};
                    line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                }
            }
        `,
    },
    contentWrapper: {
        css: css`
            display: block;
            width: 100%;
            padding-bottom: 48px;
            max-width: 1280px;
            margin: 0 auto;

            @media only screen and (max-width: 768px) {
                padding-bottom: 40px;
            }

            .spotlight {
                &-rte {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 24px;
                    @media only screen and (max-width: 1024px) {
                        flex-direction: column;
                        align-items: flex-start;
                    }
                }

                &-title {
                    font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                    line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                    font-weight: ${headlineFonts.headline2SemiBoldLg.fontWeight};
                    color: ${colorPallete.grey800};
                    @media only screen and (max-width: 768px) {
                        font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                        line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                        text-align: left;
                    }
                    @media only screen and (max-width: 1024px) {
                        margin-bottom: 8px;
                    }
                }

                &-description,
                &-description p {
                    font-size: ${bodyFonts.body1RegularLg.fontSize};
                    line-height: ${bodyFonts.body1RegularLg.lineHeight};
                    font-weight: ${bodyFonts.body1RegularLg.fontWeight};
                    text-align: left;
                    @media only screen and (max-width: 768px) {
                        font-size: ${bodyFonts.body1RegularSm.fontSize};
                        line-height: ${bodyFonts.body1RegularSm.lineHeight};
                    }
                    @media only screen and (max-width: 1024px) {
                        margin-bottom: 16px;
                    }
                }
                &-link {
                    flex-shrink: 0;
                }
            }
        `,
    },
    mainContainer: {
        gap: 0,
        css: css`
            [class*="GridOffset--"] {
                @media only screen and (max-width: 768px) {
                    justify-content: flex-end;
                }

                .btn-secondary {
                    margin-bottom: 4px;
                }
            }
        `,
    },
    prevArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-start;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                ])}
            @media only screen and (max-width: 768px) {
                display: none;
            }
        `,
    },
    prevArrowButton: {
        shape: "rounded",
        css: css`
            padding: 0;
            min-width: 40px;
            border: 1px solid ${colorPallete.grey200};
            background: ${colorPallete.white};
            color: ${colorPallete.grey800};
            z-index: 2;
            box-shadow: ${elevation.dp04};

            [class*="ButtonIcon--"] {
                color: ${colorPallete.grey800};
            }

            &:not(:disabled):hover {
                background: ${colorPallete.white};
                color: ${colorPallete.black};
                border: 1px solid ${colorPallete.grey100};

                [class*="ButtonIcon--"] {
                    color: ${colorPallete.black};
                }
            }
        `,
    },
    nextArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                ])}
            @media only screen and (max-width: 768px) {
                display: none;
            }
        `,
    },
    nextArrowButton: {
        shape: "rounded",
        css: css`
            padding: 0;
            min-width: 40px;
            border: 1px solid ${colorPallete.grey200};
            background: ${colorPallete.white};
            color: ${colorPallete.grey800};
            z-index: 2;
            box-shadow: ${elevation.dp04};

            [class*="ButtonIcon--"] {
                color: ${colorPallete.grey800};
            }

            &:not(:disabled):hover {
                background: ${colorPallete.white};
                color: ${colorPallete.black};
                border: 1px solid ${colorPallete.grey100};

                [class*="ButtonIcon--"] {
                    color: ${colorPallete.black};
                }
            }
        `,
    },
    carouselGridItem: {
        width: 10,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 90%;
                        max-width: 90%;
                    `,
                    css`
                        flex-basis: 90%;
                        max-width: 90%;
                    `,
                    css`
                        flex-basis: 90%;
                        max-width: 90%;
                    `,
                    css`
                        flex-basis: 90%;
                        max-width: 90%;
                    `,
                    css`
                        flex-basis: 90%;
                        max-width: 90%;
                    `,
                ])}
        `,
    },
    carouselWrapper: {
        css: css`
            width: 100%;
            position: relative;
        `,
    },
    carouselContainer: {
        css: css`
            overflow: hidden;
            padding: 0 0 48px 0;
        `,
    },
    carouselSlidesContainer: {
        css: css`
            display: flex;
        `,
    },
    carouselSlide: {
        css: css`
            padding: 0;
            position: relative;
            flex: 0 0 auto;
            background: ${colorPallete.white};
            box-shadow: ${elevation.dp04};
            max-width: 243px;
            margin-left: 16px;

            @media (max-width: 1024px) {
                max-width: 220px;
            }

            @media only screen and (max-width: 768px) {
                min-width: 220px;
            }
        `,
    },
    carouselSlideInner: {
        css: css`
            width: 100%;
            height: 100%;
            position: relative;
            padding: 8px 0;
            padding-bottom: 16px;
            display: flex;
            flex-direction: column;

            [data-test-selector="productImage"] {
                padding: 16px;
            }
            > div {
                display: flex;
                flex-direction: column;
                height: 100%;
            }
        `,
    },
    productSpotlightTabGroup: {
        mergeCss: true,
        cssOverrides: {
            wrapper: css`
                padding: 0;
            `,
            tabGroup: css`
                padding: 0;
                justify-content: center;
                gap: 8px;
                max-width: 1280px;
                margin: 0 auto;
                @media only screen and (min-width: 1024px) {
                    min-width: 100%;
                }
                @media only screen and (min-width: 1300px) {
                    min-width: 1280px;
                }
                @media only screen and (max-width: 768px) {
                    justify-content: flex-start;
                    overflow-x: hidden;
                    scroll-behavior: smooth;
                    padding-left: 60px;
                }
                li {
                    font-size: ${buttonFonts.buttonLg.fontSize};
                    line-height: ${buttonFonts.buttonLg.lineHeight};
                    font-family: ${buttonFonts.buttonLg.fontFamily};
                    font-weight: ${buttonFonts.buttonLg.fontWeight};
                    border: 2px solid ${colorPallete.grey300};
                    border-bottom: none;
                    border-radius: 8px 8px 0px 0px;
                    padding: 12px 40px;
                    cursor: pointer;
                    @media only screen and (min-width: 768px) {
                        flex: 1;
                    }
                    &[aria-selected="true"] {
                        background: ${colorPallete.grey100};
                    }
                    &:hover {
                        border-bottom: none;
                    }
                    :focus {
                        border-color: ${colorPallete.grey800};
                        outline: none;
                    }
                   
                    :focus:not(:focus-visible) {
                        border-color: ${colorPallete.grey300};
                        outline: none !important;  
                        outline-offset: 0 !important; 
                    }
                      
                    @media only screen and (max-width: 768px) {
                        padding: 8px 16px;
                        font-size: ${buttonFonts.buttonSm.fontSize};
                        line-height: ${buttonFonts.buttonSm.lineHeight};
                    }
                }
            `,
            tabContent: css`
                border: none;
                border-radius: 8px;
                background: ${colorPallete.grey100};
                padding: 0;
                padding-top: 48px;
                @media only screen and (max-width: 768px) {
                    padding: 40px 0;
                }
            `,
        },
    },
    tabGroupWrapper: {
        css: css`
            position: relative;
        `,
    },
    tab1: {},
    tab2: {},
    tab3: {},
    tab4: {},
    tab5: {},
};

const defaultCustomCss = `.wrapper {
}

.titleText {
}
`;

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const styles = DSGProductSpotlightCarouselStyles;

const DSGProductSpotlightCarousel = ({
    id,
    theme,
    fields,
    products,
    errorMessage,
    loadCarouselProducts,
    pageType,
    shellContext,
    productRecommendationWidgets,
    sendImpressionTracking,
    session,
}: Props) => {
    const afterCarousel = createRef<HTMLSpanElement>();
    const isProductDetailsPage = pageType === "ProductDetailsPage";
    const isProductListPage = pageType === "ProductListPage";
    const isBrandDetailsPage = pageType === "BrandDetailsPage";
    const brand = useContext(BrandStateContext).value;
    const category = useContext(CategoryContext);
    const productContext = useContext(ProductContext);

    const [currentTab, setCurrentTab] = useState("Tab1");
    const prevScrollArrow = useRef<HTMLButtonElement | null>(null) as React.MutableRefObject<HTMLButtonElement>;
    const nextScrollArrow = useRef<HTMLButtonElement | null>(null) as React.MutableRefObject<HTMLButtonElement>;
    const tabsBox = useRef<HTMLUListElement | null>(null);

    const handleScrollArrows = (scrollValue: number | undefined) => {
        let maxScrollWidth;
        if (tabsBox.current !== null) {
            maxScrollWidth = tabsBox.current.scrollWidth - tabsBox.current.clientWidth;
        }

        if (prevScrollArrow.current !== null) {
            prevScrollArrow.current.style.display = scrollValue && scrollValue <= 0 ? "none" : "block";
        }

        if (nextScrollArrow.current !== null && maxScrollWidth !== undefined) {
            nextScrollArrow.current.style.display = scrollValue && maxScrollWidth - scrollValue <= 1 ? "none" : "block";
        }
    };

    const handlePreScroll = () => {
        let scrollWidth;
        if (tabsBox.current !== null) {
            scrollWidth = tabsBox.current.scrollLeft -= 180;
        }
        handleScrollArrows(scrollWidth);
    };

    const handleNextScroll = () => {
        let scrollWidth;
        if (tabsBox.current !== null) {
            scrollWidth = tabsBox.current.scrollLeft += 240;
        }
        handleScrollArrows(scrollWidth);
    };

    useEffect(() => {
        tabsBox.current = document?.querySelector('[data-id="tabGroup"]');
    });

    const getTabsProductNumber = (productNumbers: any[]) => {
        if (!productNumbers || productNumbers.length === 0) {
            return;
        }
        const productsSpotlight = [] as string[];
        productNumbers.forEach(r => {
            productsSpotlight.push(r.fields.productNumbers);
        });
        return productsSpotlight;
    };
    const [title, setTitle] = useState(fields.title);
    const tab1Label = fields.tab1Label;
    const tab1Content = fields.tab1Content;
    const tab1ProductNumbers = fields.tab1ProductNumbers;

    const tab2Label = fields.tab2Label;
    const tab2Content = fields.tab2Content;
    const tab2ProductNumbers = fields.tab2ProductNumbers;

    const tab3Label = fields.tab3Label;
    const tab3Content = fields.tab3Content;
    const tab3ProductNumbers = fields.tab3ProductNumbers;

    const tab4Label = fields.tab4Label;
    const tab4Content = fields.tab4Content;
    const tab4ProductNumbers = fields.tab4ProductNumbers;

    const tab5Label = fields.tab5Label;
    const tab5Content = fields.tab5Content;
    const tab5ProductNumbers = fields.tab5ProductNumbers;

    const tabbedProductNumbers = getTabsProductNumber(fields.tab1ProductNumbers) as string[] | undefined;
    const [carouselProducts, setCarouselProducts] = useState(tabbedProductNumbers);
    const [active, setActive] = useState("Tab1");
    const [currentTabLabel, setCurrentTabLabel] = useState(tab1Label);
    const tabbedContents = fields.tab1Content as string | "";
    const [carouselContent, setCarouselContent] = useState(tabbedContents);

    const [tabbedCarouselId, setTabbedCarouselId] = useState(id);
    const getProductNumbersList = (productNumbers: any[], content: any, tabId: string, tabLabel: string) => {
        if (!productNumbers || productNumbers.length === 0) {
            return;
        }

        setTabbedCarouselId(tabId);
        const productsSpotlight = getTabsProductNumber(productNumbers);
        setCarouselProducts(productsSpotlight);
        setCarouselContent(content);
        setActive(tabId);
        setCurrentTabLabel(tabLabel);
        setCurrentTab(tabId);
    };
    const trackSelectPromotion = (product: ProductModel) => {
        trackSelectPromotionEvent(tabbedCarouselId, currentTab, currentTabLabel, title, product);
    };
    const mapProductsToSlides = (products: ProductModel[]) =>
        products.map(product => ({
            id: product.id,
            renderComponent: function DSGProductCarouselProductRenderer() {
                return (
                    <div onClick={() => trackSelectPromotion(product)}>
                        <DSGProductCarouselProduct
                            carouselId={id}
                            key={product.id}
                            product={product}
                            // recommendationId={getProductRecommendationId(product)}
                            showImage={fields.showImage}
                            showBrand={showBrandBlocks}
                            showTitle={fields.showTitle}
                            showPartNumbers={fields.showPartNumbers}
                            showPrice={fields.showPrice}
                            showAddToCart={fields.showAddToCart}
                            showAddToList={fields.showAddToList}
                            showImageBadges={fields.showImageBadges}
                            maximumNumberOfImageBadges={fields.maximumNumberOfImageBadges}
                            showTextBadges={fields.showTextBadges}
                            maximumNumberOfTextBadges={fields.maximumNumberOfTextBadges}
                            extendedStyles={styles.carouselProductStyles}
                            showViewProduct={fields.showViewProduct}
                            showQtyBox={false}
                        />
                    </div>
                );
            },
        }));
    const [slides, setSlides] = useState<CarouselSlide[]>(products ? mapProductsToSlides(products) : []);
    useEffect(() => {
        if (!products || products.length === 0) {
            return;
        }

        setSlides(mapProductsToSlides(products));
    }, [products]);

    useEffect(() => {
        const productNumbers = carouselProducts;
        loadCarouselProducts({
            isShellEdit: shellContext.isInShell && shellContext.isEditing,
            carouselId: id,
            carouselType: `SpotlightPromotion|${title}|${currentTabLabel}|${currentTab}`,
            relatedProductType: fields.relatedProductType,
            seedWithManuallyAssigned: fields.seedWithManuallyAssigned,
            displayProductsFrom: fields.displayProductsFrom,
            selectedCategoryIds: fields.selectedCategoryIds,
            numberOfProductsToDisplay: fields.numberOfProductsToDisplay,
            widgetPosition: fields.widgetPosition,
            isProductDetailsPage,
            productId: productContext?.product?.id,
            isProductListPage,
            category,
            isBrandDetailsPage,
            brand,
            productNumbers,
        } as any);
    }, [carouselProducts]);

    const [emblaRef, embla] = useEmblaCarousel();
    const [windowResizeTime, setWindowResizeTime] = useState(0);
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);
    const setCanScroll = () => {
        if (shellContext.isInShell) {
            return;
        }
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };

    const getSlidesToScroll = useCallback(() => {
        const maxNumberOfColumns = (fields.maxNumberOfColumns && fields.maxNumberOfColumns) || 5;
        if (typeof window === "undefined") {
            return maxNumberOfColumns;
        }

        let localSlidesToScroll: number;
        const { innerWidth } = window;
        if (innerWidth < theme.breakpoints.values[1]) {
            localSlidesToScroll = 1;
        } else if (innerWidth < theme.breakpoints.values[2]) {
            localSlidesToScroll = 2;
        } else if (innerWidth < theme.breakpoints.values[3]) {
            localSlidesToScroll = 3;
        } else if (innerWidth >= theme.breakpoints.maxWidths[4]) {
            localSlidesToScroll = 5;
        } else {
            localSlidesToScroll = 5;
        }
        return Math.min(localSlidesToScroll, maxNumberOfColumns);
    }, [fields.maxNumberOfColumns]);

    const [slidesToScroll, setSlidesToScroll] = useState(0);

    useEffect(() => {
        const newSlidesToScroll = getSlidesToScroll();
        setSlidesToScroll(newSlidesToScroll);
    }, [fields.maxNumberOfColumns, windowResizeTime]);

    useEffect(() => {
        if (!embla) {
            return;
        }

        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);

        const onWindowResize = () => {
            setWindowResizeTime(Date.now());
        };

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, [embla]);

    useEffect(() => {
        if (!embla || !products || products.length === 0) {
            return;
        }

        embla.reInit({
            align: "start",
            slidesToScroll,
            draggable: isTouchDevice(),
            loop: products.length > slidesToScroll,
        });
        setCanScroll();
    }, [embla, slidesToScroll, products]);

    useEffect(() => {
        if (
            fields.carouselType !== "recommendedProducts" ||
            !productRecommendationWidgets ||
            fields.widgetPosition > productRecommendationWidgets.length ||
            !products
        ) {
            return;
        }

        const productRecommendationWidget = productRecommendationWidgets[fields.widgetPosition - 1];
        const recommendationIds: number[] = [];
        products?.forEach(o => {
            const id = productRecommendationWidget.recs.find(r => r.refCode === o.detail?.name)?.id;
            if (id) {
                recommendationIds.push(id);
            }
        });

        if (recommendationIds.length) {
            sendImpressionTracking({ recommendationIds });
        }
    }, [fields.carouselType, productRecommendationWidgets, products]);

    const getProductRecommendationId = (product: ProductModel) => {
        if (!productRecommendationWidgets || fields.widgetPosition > productRecommendationWidgets.length) {
            return;
        }

        const productRecommendationWidget = productRecommendationWidgets[fields.widgetPosition - 1];
        return productRecommendationWidget.recs.find(r => r.refCode === product.detail?.name)?.id;
    };

    if (errorMessage && shellContext.isInShell) {
        return (
            <Typography {...styles.errorMessageText} as="p">
                {`Failed to load carousel products. Error: '${errorMessage}'. Please check widget settings.`}
            </Typography>
        );
    }

    if (!products || products.length === 0) {
        return null;
    }

    const showBrandBlocks = fields.showBrandName && products.some(o => !!o.brand);
    const customCssWrapper = {
        css: css`
            ${fields.customCSS}
        `,
    };

    const tabs = [] as any;
    if (tab1ProductNumbers && tab1ProductNumbers.length > 0) {
        tabs.push(
            <Tab
                {...styles.tab1}
                selected={currentTab === "Tab1"}
                key="Tab1"
                tabKey="Tab1"
                headline={translate(tab1Label)}
                className="tab-item"
                onSelect={key => setCurrentTab("Tab1")}
                onClick={e => getProductNumbersList(tab1ProductNumbers, tab1Content, "Tab1", tab1Label)}
            >
                <ContentWrapper alignment={fields.titleAlignment} className="wrapper" {...styles.contentWrapper}>
                    <Typography {...styles.titleText}>
                        {parse(carouselContent, parserOptions)}
                    </Typography>
                </ContentWrapper>
                <Carousel
                    id="Tab1"
                    maxNumberOfColumns={5}
                    title=""
                    slides={slides}
                    extendedStyles={DSGProductSpotlightCarouselStyles}
                />
            </Tab>,
        );
    }
    if (tab2ProductNumbers && tab2ProductNumbers.length > 0) {
        tabs.push(
            <Tab
                {...styles.tab2}
                selected={currentTab === "Tab2"}
                key="Tab2"
                tabKey="Tab2"
                headline={translate(tab2Label)}
                onSelect={key => setCurrentTab("Tab2")}
                onClick={e => getProductNumbersList(tab2ProductNumbers, tab2Content, "Tab2", tab2Label)}
            >
                <ContentWrapper alignment={fields.titleAlignment} className="wrapper" {...styles.contentWrapper}>
                    <Typography {...styles.titleText}>
                        {parse(carouselContent, parserOptions)}
                    </Typography>
                </ContentWrapper>
                <Carousel
                    id="Tab2"
                    maxNumberOfColumns={5}
                    title=""
                    slides={slides}
                    extendedStyles={DSGProductSpotlightCarouselStyles}
                />
            </Tab>,
        );
    }
    if (tab3ProductNumbers && tab3ProductNumbers.length > 0) {
        tabs.push(
            <Tab
                {...styles.tab3}
                selected={currentTab === "Tab3"}
                key="Tab3"
                tabKey="Tab3"
                headline={translate(tab3Label)}
                onSelect={key => setCurrentTab("Tab3")}
                onClick={e => getProductNumbersList(tab3ProductNumbers, tab3Content, "Tab3", tab3Label)}
            >
                <ContentWrapper alignment={fields.titleAlignment} className="wrapper" {...styles.contentWrapper}>
                    <Typography {...styles.titleText}>
                        {parse(carouselContent, parserOptions)}
                    </Typography>
                </ContentWrapper>
                <Carousel
                    id="Tab3"
                    maxNumberOfColumns={5}
                    title=""
                    slides={slides}
                    extendedStyles={DSGProductSpotlightCarouselStyles}
                />
            </Tab>,
        );
    }
    if (tab4ProductNumbers && tab4ProductNumbers.length > 0) {
        tabs.push(
            <Tab
                {...styles.tab4}
                selected={currentTab === "Tab4"}
                key="Tab4"
                tabKey="Tab4"
                headline={translate(tab4Label)}
                onSelect={key => setCurrentTab("Tab4")}
                onClick={e => getProductNumbersList(tab4ProductNumbers, tab4Content, "Tab4", tab4Label)}
            >
                <ContentWrapper alignment={fields.titleAlignment} className="wrapper" {...styles.contentWrapper}>
                    <Typography {...styles.titleText}>
                        {parse(carouselContent, parserOptions)}
                    </Typography>
                </ContentWrapper>
                <Carousel
                    id="Tab4"
                    maxNumberOfColumns={5}
                    title=""
                    slides={slides}
                    extendedStyles={DSGProductSpotlightCarouselStyles}
                />
            </Tab>,
        );
    }
    if (tab5ProductNumbers && tab5ProductNumbers.length > 0) {
        tabs.push(
            <Tab
                {...styles.tab5}
                selected={currentTab === "Tab5"}
                key="Tab5"
                tabKey="Tab5"
                headline={translate(tab5Label)}
                onSelect={key => setCurrentTab("Tab5")}
                onClick={e => getProductNumbersList(tab5ProductNumbers, tab5Content, "Tab5", tab5Label)}
            >
                <ContentWrapper alignment={fields.titleAlignment} className="wrapper" {...styles.contentWrapper}>
                    <Typography {...styles.titleText}>  
                        {parse(carouselContent, parserOptions)}
                    </Typography>
                </ContentWrapper>
                <Carousel
                    id="Tab5"
                    maxNumberOfColumns={5}
                    title=""
                    slides={slides}
                    extendedStyles={DSGProductSpotlightCarouselStyles}
                />
            </Tab>,
        );
    }

    return (
        <StyledWrapper {...customCssWrapper}>
            <>
                <SkipNav
                    text={translate("Skip Carousel")}
                    extendedStyles={styles.skipCarouselButton}
                    destination={afterCarousel}
                />
                <ContentWrapper alignment={fields.titleAlignment} className="wrapper" {...styles.sectionContentWrapper}>
                    <Typography {...styles.titleText}>{title}</Typography>
                </ContentWrapper>
                <StyledWrapper className="tab-button-wrapper" {...styles.tabGroupWrapper}>
                    <PreArrow aria-label={translate('Previous Arrow')} data-test-selector="prevTabBtn" ref={prevScrollArrow} onClick={handlePreScroll}>
                        <ButtonIcon src={ChevronLeft} />
                    </PreArrow>
                    <TabGroup {...styles.productSpotlightTabGroup} key="productSpotlightTabGroup">
                        {/* current={currentTab} onTabChange={onTabChange}> */}
                        {tabs}
                    </TabGroup>
                    <NextArrow aria-label={translate('Next Arrow')} data-test-selector="nextTabBtn" ref={nextScrollArrow} onClick={handleNextScroll}>
                        <ButtonIcon src={ChevronRight} />
                    </NextArrow>
                </StyledWrapper>
            </>
        </StyledWrapper>
    );
};

export const ContentWrapper = styled.div<InjectableCss & { alignment: string }>`
    display: flex;
    width: 100%;
    justify-content: ${props => props.alignment ?? "flex-start"};
    ${injectCss};
`;

const CarouselSlidesContainer = styled.div`
    display: flex;
`;

const CarouselSlide = styled.div`
    padding: 0;
    position: relative;
    flex: 0 0 auto;
`;

const CarouselSlideInner = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
`;

const ProductImage = styled.div`
    width: 145px;
    height: 145px;
    background-color: #e0e0e0;
`;
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withIsInShell(withTheme(DSGProductSpotlightCarousel))),
    definition: {
        group: "Common",
        icon: "gallery-thumbnails",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                sortOrder: 0,
                tab: basicTab,
            },
            {
                name: fields.tab1Label,
                displayName: "Tab 1 Label",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                sortOrder: 1,
                tab: basicTab,
            },
            {
                name: fields.tab1Content,
                displayName: "Tab 1 Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                validate: (html: string) => {
                    const arrayOfStyles = extractStylesToArray(html);
                    return arrayOfStyles?.every(style => isSafe(style))
                        ? null
                        : "The HTML contains invalid styles that prevent it from being saved";
                },
                tab: basicTab,
                sortOrder: 2,
            },
            {
                name: fields.tab1ProductNumbers,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields, state) => {
                    return item.fields.productNumbers;
                },
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "productNumbers",
                        displayName: "",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                ],
                tab: basicTab,
                sortOrder: 3,
            },
            {
                name: fields.tab2Label,
                displayName: "Tab 2 Label",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                sortOrder: 4,
                tab: basicTab,
            },
            {
                name: fields.tab2Content,
                displayName: "Tab 2 Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                validate: (html: string) => {
                    const arrayOfStyles = extractStylesToArray(html);
                    return arrayOfStyles?.every(style => isSafe(style))
                        ? null
                        : "The HTML contains invalid styles that prevent it from being saved";
                },
                tab: basicTab,
                sortOrder: 4,
            },
            {
                name: fields.tab2ProductNumbers,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields, state) => {
                    return item.fields.productNumbers;
                },
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "productNumbers",
                        displayName: "",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                ],
                tab: basicTab,
                sortOrder: 5,
            },
            {
                name: fields.tab3Label,
                displayName: "Tab 3 Label",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                sortOrder: 6,
                tab: basicTab,
            },
            {
                name: fields.tab3Content,
                displayName: "Tab 3 Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                validate: (html: string) => {
                    const arrayOfStyles = extractStylesToArray(html);
                    return arrayOfStyles?.every(style => isSafe(style))
                        ? null
                        : "The HTML contains invalid styles that prevent it from being saved";
                },
                tab: basicTab,
                sortOrder: 7,
            },
            {
                name: fields.tab3ProductNumbers,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields, state) => {
                    return item.fields.productNumbers;
                },
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "productNumbers",
                        displayName: "",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                ],
                tab: basicTab,
                sortOrder: 8,
            },
            {
                name: fields.tab4Label,
                displayName: "Tab 4 Label",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                sortOrder: 9,
                tab: basicTab,
            },
            {
                name: fields.tab4Content,
                displayName: "Tab 4 Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                validate: (html: string) => {
                    const arrayOfStyles = extractStylesToArray(html);
                    return arrayOfStyles?.every(style => isSafe(style))
                        ? null
                        : "The HTML contains invalid styles that prevent it from being saved";
                },
                tab: basicTab,
                sortOrder: 10,
            },
            {
                name: fields.tab4ProductNumbers,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields, state) => {
                    return item.fields.productNumbers;
                },
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "productNumbers",
                        displayName: "",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                ],
                tab: basicTab,
                sortOrder: 11,
            },
            {
                name: fields.tab5Label,
                displayName: "Tab 5 Label",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                sortOrder: 12,
                tab: basicTab,
            },
            {
                name: fields.tab5Content,
                displayName: "Tab 5 Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                validate: (html: string) => {
                    const arrayOfStyles = extractStylesToArray(html);
                    return arrayOfStyles?.every(style => isSafe(style))
                        ? null
                        : "The HTML contains invalid styles that prevent it from being saved";
                },
                tab: basicTab,
                sortOrder: 13,
            },
            {
                name: fields.tab5ProductNumbers,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields, state) => {
                    return item.fields.productNumbers;
                },
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "productNumbers",
                        displayName: "",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                ],
                tab: basicTab,
                sortOrder: 14,
            },
            {
                name: fields.showImage,
                displayName: "Image",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => false,
                fieldType: "Contextual",
                sortOrder: 15,
                tab: basicTab,
            },
            {
                name: fields.showTitle,
                displayName: "Title",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => true,
                fieldType: "Contextual",
                sortOrder: 16,
                tab: basicTab,
            },
            {
                name: fields.showBrandName,
                displayName: "Brand Name",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                sortOrder: 17,
                tab: basicTab,
            },
            {
                name: fields.showPartNumbers,
                displayName: "Part Numbers",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                sortOrder: 18,
                tab: basicTab,
            },
            {
                name: fields.showPrice,
                displayName: "Price",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                sortOrder: 19,
                tab: basicTab,
            },
            {
                name: fields.showAddToCart,
                displayName: "Add to Cart",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                sortOrder: 20,
                tab: basicTab,
            },
            {
                name: fields.showViewProduct,
                displayName: "View Product",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                sortOrder: 21,
                tab: basicTab,
            },
            {
                name: fields.showAddToList,
                displayName: "Add to List",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                sortOrder: 22,
                tab: basicTab,
            },
            {
                name: fields.showImageBadges,
                displayName: "Image Badges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                sortOrder: 23,
                tab: basicTab,
            },
            {
                name: fields.maximumNumberOfImageBadges,
                editorTemplate: "DropDownField",
                isVisible: widget => widget.fields.showImageBadges,
                defaultValue: "4",
                options: [
                    { displayName: "1", value: "1" },
                    { displayName: "2", value: "2" },
                    { displayName: "3", value: "3" },
                    { displayName: "4", value: "4" },
                    { displayName: "5", value: "5" },
                    { displayName: "6", value: "6" },
                    { displayName: "7", value: "7" },
                    { displayName: "8", value: "8" },
                ],
                fieldType: "Contextual",
                sortOrder: 24,
                tab: basicTab,
            },
            {
                name: fields.showTextBadges,
                displayName: "Text Badges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                sortOrder: 25,
                tab: basicTab,
            },
            {
                name: fields.maximumNumberOfTextBadges,
                editorTemplate: "DropDownField",
                isVisible: widget => widget.fields.showTextBadges,
                defaultValue: "4",
                options: [
                    { displayName: "1", value: "1" },
                    { displayName: "2", value: "2" },
                    { displayName: "3", value: "3" },
                    { displayName: "4", value: "4" },
                    { displayName: "5", value: "5" },
                    { displayName: "6", value: "6" },
                    { displayName: "7", value: "7" },
                    { displayName: "8", value: "8" },
                ],
                fieldType: "Contextual",
                sortOrder: 26,
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
